import {Form} from '../../../application/forms/form';

class SubscriptionForm extends Form
{
    get data() {
        const data = {email: this.container.querySelector('[name="email"]').value};

        const source = this.container.querySelector('[name="source"]');

        if (source && source.value) {
            data.source = source.value;
        }

        return data;
    }
}

export {SubscriptionForm};
